// extracted by mini-css-extract-plugin
export default {"setting--inverted":"VWSIhz2","dark-theme":"Qcs2BwG","notificationBadge":"U_HLCnk","hasValue":"MZ5MdIa","s200":"RVbKycB"};